
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as ht from './_ht';
import * as gs from './_csGbl';

export const setAsync = async () => {
  const _gUserz = gs.useUserz();
  await _gUserz.saveAsync({ // wait しない, onPress のみ対象
    ornDtm: hfDTM.getNow()
  });
};

export const chkClw = (
  ivl: ht.n, // interval milli second
  ftn: (_drc: ht.n) => ht.b // function
) => {
  hf.clw(ivl, () => {
    const _gUserz = gs.useUserz();
    if (!_gUserz.crt.ornDtm) setAsync();
//hf.l(`cmODT 21: ${_gUserz.crt.ornDtm} ${hfDTM.getNow()}`);
    const _drc = hfDTM.getDrcMnt(_gUserz.crt.ornDtm, hfDTM.getNow());
    return ftn(_drc);
  })
};
